const buttonArrows = document.querySelectorAll(".submenu-arrow");

// buttonArrows.forEach(button => {
//     //console.log(button)
//     button.onclick = function(){

// const parent = this.parentElement;
// const submenu = parent.nextElementSibling;

//      //   console.log(submenu);

//         submenu.classList.toggle("show");
//     };
// });

window.onload = (event) => {
  //  console.log("page is fully loaded");

  //check if link is just #

  const links = document.querySelectorAll(".nav-menu a");

  links.forEach((link) => {
    const url = link.href;
    let slug = (url) => new URL(url).pathname.match(/[^\/]+/g);

    if (url.includes("#")) {
      // console.log(url);
      link.removeAttribute("href");
    }
  });

  // every time you leave(blur) a link in side menu, wait a few sec and check if other has focus, if not, close menu

  $(".sub-menu a").blur(function () {
    setTimeout(function () {
      if (!$(".sub-menu a").is(":focus")) {
        setTimeout(function () {
          $(".sub-menu").css({
            display: "none",
          });
        }, 500);

        $(".menu-item-has-children").removeClass("submenu-open");
      }
    }, 100);
  });
};
